<template>
  <div>
    <!-- <div>{{searchMethod}}</div> -->
    <a-input-group compact :id="$options.name+'Srcbox'">
      <template v-for="[key,value] in Object.entries(items)">
        <!-- 下拉选择 -->
        <a-select v-if="value.type==='select'" :key="key" :size="size" v-model="value.value" :style="value.style">
          <a-select-option v-for="v in value.selectData" :key="v.dicKey">{{v.dicValue}}</a-select-option>
        </a-select>
        <!-- 多选 -->
        <a-select
          v-if="value.type==='multipleSelect'"
          mode="multiple"
          allowClear
          :key="key"
          :size="size"
          v-model="value.value"
          :style="value.style"
          :maxTagCount="1"
          :placeholder="value.placeholder"
        >
          <a-select-option v-for="v in value.selectData" :key="v.dicKey">{{v.dicValue}}</a-select-option>
        </a-select>
        <!-- 输入搜索并选择 -->
        <a-select
          v-if="value.type==='inputSelect'"
          :key="key"
          :size="size"
          v-model="value.value"
          :style="value.style"
          showSearch
          :filterOption="false"
          @search="value.search"
        >
          <a-select-option value>{{value.placeholder}}</a-select-option>
          <a-select-option v-for="v in value.selectData" :key="v.dicKey">{{v.dicValue}}</a-select-option>
        </a-select>
        <!-- 输入 -->
        <a-input
          v-if="value.type==='input'"
          :key="key"
          :size="size"
          :style="value.style"
          :placeholder="value.placeholder"
          v-model="value.value"
        />
        <!-- 带搜素按钮输入 -->
        <a-input-search
          v-if="value.type==='inputSearch'"
          enterButton
          :size="size"
          :key="key"
          :style="value.style"
          @search="searchMethod"
          :placeholder="value.placeholder"
          v-model="value.value"
        />
        <!-- 日期范围 -->
        <a-range-picker
          v-if="value.type==='dateRange'"
          :size="size"
          :key="key"
          :style="value.style"
          :placeholder="value.placeholder"
          v-model="value.value"
        />
        <!-- 月份范围 -->
        <a-range-picker
          v-if="value.type==='monthRange'"
          :size="size"
          :key="key"
          :style="value.style"
          :placeholder="value.placeholder"
          v-model="value.value"
          format="YYYY-MM"
          :mode="['month','month']"
          @panelChange="(v,m)=>{monthRangePanelChange(v,m,value)}"
          @change="(v,m)=>{monthRangeChange(v,m,value)}"
        />

        <srm-month-picker v-if="value.type==='monthPickerRange'" :key="key" :param="value" :size="size" />
      
        <!-- 月份 -->
        <a-month-picker
          v-if="value.type === 'month'"
          :size="size"
          :key="key"
          :style="value.style"
          :placeholder="value.placeholder"
          v-model="value.value"
          format="YYYY-MM"
        />
      </template>
    </a-input-group>
  </div>
</template>

<script>
export default {
  mounted() {
    if (Boolean(this.getDictionary)) {
      for (let key in this.items) {
        let value = this.items[key];
        if (Boolean(value.dictionaryUrl)) {
          this.getDictionary(value.dictionaryUrl, key, (res, key) => {
            if (Boolean(value.render) && typeof value.render === 'function')
              res.data = value.render(res.data);
            value.selectData = value.selectData.concat(res.data);
          });
        }
        // 绑定作用域
        if (Boolean(value.search) && typeof value.search === 'function') {
          value.search = value.search.bind(value);
        }
      }
    }
    // 设置搜索栏的数据解析方法
    if (Boolean(this.point) && Boolean(this.point.srmSearchOption))
      this.point.srmSearchOption.getData = this.search;
  },
  methods: {
    search() {
      let obj = {};
      for (let key in this.items) {
        let value = this.items[key];
        if (value.type === "multipleSelect")
          obj[key] = value.value.toString();
        else if (value.type === "input" || value.type === "inputSearch")
          obj[key] = P.trim(value.value);
        else if (value.type === 'dateRange') {
          if ((value.value instanceof Array) && Boolean(value.value[0]) && Boolean(value.value[1])) {
            let dateStr = value.dateStr || 'YYYY-MM-DD';
            obj[key] = [value.value[0].format(dateStr), value.value[1].format(dateStr)];
          } else
            obj[key] = ['', ''];
        }
        else if (value.type === 'monthRange') {
          if ((value.value instanceof Array) && Boolean(value.value[0]) && Boolean(value.value[1])) {
            let dateStr = value.dateStr || 'YYYY-MM';
            obj[key] = [value.value[0].format(dateStr), value.value[1].format(dateStr)];
          } else
            obj[key] = ['', ''];
        }
        else if (value.type === 'month') {
          let dateStr = value.dateStr || 'YYYYMM';
          obj[key] = value.value ? value.value.format(dateStr) : '';
        }
        else
          obj[key] = value.value;

        // 根据setData，把值赋值到另外的字段
        if (Boolean(value.setData)) {
          // setData和obj[key]均为数组
          if (value.setData instanceof Array && obj[key] instanceof Array) {
            for (let i = 0; i < value.setData.length; i++) {
              let data = obj[key][i];
              if (data !== undefined) {
                obj[value.setData[i]] = data;
              }
            }
          }
        }
      }
      return obj;
    },
    monthRangePanelChange(value, mode, obj) {
      obj.value = value;
    },
    monthRangeChange(value, mode, obj) {
      obj.value = value;
    },
  },
  props: {
    size: String,
    getDictionary: Function,
    items: {
      type: Object,
      required: true,
      validator: (item) => {
        // type值必须匹配下列字符串中的一个
        const itemType = ['select', 'input', 'inputSearch', 'inputSelect', 'multipleSelect', 'dateRange', 'monthRange'];
        for (let [key, value] of Object.entries(item)) {
          if (!itemType.includes(value.type)) {
            return false;
          }
        }
        return true;
      }
    },
    searchMethod: {
      type: Function,
      required: true
    },
    point: Object,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/srm-search/srm-search.vue